import { cva, type VariantProps } from 'class-variance-authority'
import { forwardRef, type ReactNode } from 'react'
import { cn } from '../../shared/cn'

const textDecoratorVariants = cva('', {
  variants: {
    variant: {
      algosecondary: 'text-algosecondary font-semibold',
      algoprimary: 'text-algoprimary font-semibold',
      gradient:
        'text-bold bg-gradient-to-br from-algoprimary to-algosecondary bg-clip-text text-transparent'
    }
  }
})

type TextDecoratorVariants = VariantProps<typeof textDecoratorVariants>

type TextDecoratorProps = TextDecoratorVariants & {
  children: ReactNode
  gradientColor?: string
}

export const TextDecorator = forwardRef<HTMLSpanElement, TextDecoratorProps>(
  ({ variant, gradientColor, ...props }, ref) => {
    return (
      <span
        className={cn(
          textDecoratorVariants({ variant }),
          gradientColor && 'bg-gradient-to-r bg-clip-text text-bold text-transparent',
          gradientColor
        )}
        ref={ref}
        {...props}
      >
        {props.children}
      </span>
    )
  }
)
TextDecorator.displayName = 'TextDecorator'
